import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import Layout from '../components/layout';
import Overview from '../components/Overview';
import MainCategory from '../components/MainCategory';
import PropertyItem from '../components/PropertyItem';
import FunctionItem from '../components/FunctionItem';
import '../styles/main.scss';

var ApiPage = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ApiPage, _React$Component);

  function ApiPage() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ApiPage.prototype;

  _proto.render = function render() {
    // eslint-disable-line complexity
    var _this$props$location = this.props.location,
        pathname = _this$props$location.pathname,
        hash = _this$props$location.hash;
    var _this$props$data$apiP = this.props.data.apiPageJson,
        parentPid = _this$props$data$apiP.parentPid,
        title = _this$props$data$apiP.title,
        items = _this$props$data$apiP.items;
    var selectedNavItemId = "" + pathname.split('/').pop() + hash;
    var overview = items.filter(function (item) {
      return item.type === 'overview';
    });
    var staticProperies = items.filter(function (item) {
      return item.type === 'static-property';
    });
    var staticMethods = items.filter(function (item) {
      return item.type === 'static-method';
    });
    var instanceMethods = items.filter(function (item) {
      return item.type === 'instance-method';
    });
    var events = items.filter(function (item) {
      return item.type === 'event';
    });
    var typedef = items.filter(function (item) {
      return item.type === 'typedef';
    });
    var hasProperties = parentPid === 'typedef' ? !!overview[0].types.names.find(function (type) {
      return type === 'object';
    }) : false;
    return /*#__PURE__*/React.createElement(Layout, {
      tabIndex: 0,
      selectedNavItemId: selectedNavItemId
    }, /*#__PURE__*/React.createElement("header", null, /*#__PURE__*/React.createElement("h2", {
      className: "title"
    }, title)), /*#__PURE__*/React.createElement("article", null, overview.length ? /*#__PURE__*/React.createElement(Overview, {
      parentPid: parentPid,
      data: overview[0],
      hasProperties: hasProperties
    }) : null, staticProperies.length ? /*#__PURE__*/React.createElement(MainCategory, {
      title: "Static Properties"
    }, staticProperies.map(function (item, index) {
      return /*#__PURE__*/React.createElement(PropertyItem, {
        key: "static-method-" + index,
        data: item
      });
    })) : null, staticMethods.length ? /*#__PURE__*/React.createElement(MainCategory, {
      title: "Static Methods"
    }, staticMethods.map(function (item, index) {
      return /*#__PURE__*/React.createElement(FunctionItem, {
        key: "static-method-" + index,
        data: item
      });
    })) : null, instanceMethods.length ? /*#__PURE__*/React.createElement(MainCategory, {
      title: "Instance Methods"
    }, instanceMethods.map(function (item, index) {
      return /*#__PURE__*/React.createElement(FunctionItem, {
        key: "instance-method-" + index,
        data: item
      });
    })) : null, events.length ? /*#__PURE__*/React.createElement(MainCategory, {
      title: "Events"
    }, events.map(function (item, index) {
      return /*#__PURE__*/React.createElement(FunctionItem, {
        key: "event-" + index,
        data: item
      });
    })) : null, typedef.length ? /*#__PURE__*/React.createElement(MainCategory, {
      title: "Typedef"
    }, typedef.map(function (item, index) {
      return /*#__PURE__*/React.createElement(FunctionItem, {
        key: "" + index,
        data: item
      });
    })) : null));
  };

  return ApiPage;
}(React.Component);

export default ApiPage;
var query = "3333492170";